<h1 class="watermark_container" data-test="watermark" [ngClass]="className">
    <span data-test="watermarkContent" *ngFor="let item of itemCount">{{content}}</span>
</h1>